import type { CanBuilder } from "../types";
import type { GetAiaQuestionnaireApiResponse } from "@/services/schemas";
import { defineSpecialistRules } from "./specialist";

type AiaQuestionnaireUpdateConditions = {
	status: GetAiaQuestionnaireApiResponse["status"][0]["label"];
};

type AiaQuestionnaireSubmitConditions = {
	status: GetAiaQuestionnaireApiResponse["status"][0]["label"];
	sections: GetAiaQuestionnaireApiResponse["sections"];
};

export function defineSojurRules(can: CanBuilder): void {
	defineSpecialistRules(can);

	can("create", "AIA");
	can("update", "AIA");

	can("create", "AIAQuestionnaire");

	can(
		"update",
		"AIAQuestionnaire",
		({ status }: AiaQuestionnaireUpdateConditions) =>
			status === "Em elaboração" || status === "Em edição",
	);

	can(
		"submit",
		"AIAQuestionnaire",
		({ status, sections }: AiaQuestionnaireSubmitConditions) =>
			(status === "Em elaboração" || status === "Em edição") &&
			sections.every(({ questions }) => questions.length > 0) &&
			sections.every(({ questions }) =>
				questions.every(
					({ principles, weight }) => principles.length > 0 && weight > 0,
				),
			),
	);
}
